import { Box, styled } from "@mui/material";
import modelTasks from "../../constants/modelTasks.json";

const getModelTaskColor = (type) => {
  const match = modelTasks.find((task) => task.value === type);
  return match?.color || "#7180a0"; // fallback default color
};

const ModelTaskBox = styled(Box)(({ type }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "4px 12px",
  borderRadius: "12px",
  color: "white",
  backgroundColor: getModelTaskColor(type),
  fontWeight: "bold",
  textAlign: "center",
  minWidth: 0,
  whiteSpace: "nowrap",
}));

export default ModelTaskBox;
